// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3uk6h","errorLogs":"EditorFooter_errorLogs__3wGyr"};